export const PRICE_RANGE_SALE_100 = "ONE_HUNDRED";
export const PRICE_RANGE_SALE_500 = "FIVE_HUNDRED";
export const PRICE_RANGE_SALE_1000 = "ONE_THOUSAND";
export const PRICE_RANGE_SALE_2000 = "TWO_THOUSAND";
export const PRICE_RANGE_SALE_MORE = "MORE";
